import React, { useState } from 'react';
import { withUserWriteAccess } from 'contexts/adminAccess';
import { useDataProvider, useRefresh, useNotify } from 'react-admin';

import { Button, makeStyles } from '@material-ui/core';
import { UserDetails } from '../types';

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
    color: theme.palette.secondary.contrastText,
  },
}));

interface Props {
  user: UserDetails;
}

const SmallPackagesAllowButton = ({ user }: Props) => {
  const { smallPackagesAllowedAt, id: rolloId } = user;

  const [enabled, setEnabled] = useState<boolean>(!smallPackagesAllowedAt);

  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [loading, setLoading] = useState<boolean>(false);

  const handleToggleSmallPackagesAllow = async () => {
    try {
      setLoading(true);

      const response = await dataProvider.post('smallPackagesAllow', {
        userId: rolloId,
        smallPackagesAllow: enabled,
      });

      setEnabled(!enabled);

      refresh();

      return response;
    } catch (error: any) {
      notify(
        typeof error === 'string' ? error : error.message || 'ra.notification.http_error',
        'warning'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      onClick={handleToggleSmallPackagesAllow}
      disabled={loading}
      className={classes.button}>
      {smallPackagesAllowedAt ? 'Show alerts' : 'Hide alerts'}
    </Button>
  );
};

export default withUserWriteAccess(SmallPackagesAllowButton);
